import React from 'react'
import {
  ModalBody,
  ModalFooterInForm,
  ModalHeader,
  ModalWrapper,
} from '~/components/common/Modal'
import { useForm } from 'react-hook-form'
import { post } from '~/utils/api'
import TicketForm from '../../list/addTicket/TicketForm'
import SelectClient from '../../list/addTicket/SelectClient'
import { TicketType } from '~/components/tickets/Show'

type PropsType = {
  ticket: TicketType
  editModal: boolean
  setEditModal: (editModal: boolean) => void
}

type EditFormValues = {
  title: string
  ticketCategory: number | null
  ticketSubcategory: number | null
  deadline: Date | null | string
  client: string | null
}

const EditModal: React.FC<PropsType> = ({
  ticket,
  editModal,
  setEditModal,
}) => {
  const defaultValues = () => ({
    title: ticket.title,
    client: ticket.client ? ticket.client.name : null,
    deadline: '',
    ticketCategory: ticket.category ? ticket.category.id : null,
    ticketSubcategory: ticket.subcategory ? ticket.subcategory.id : null,
  })

  const close = () => {
    setEditModal(false)
    reset()
  }

  const {
    register,
    handleSubmit,
    control,
    formState: { isSubmitting },
    setError,
    reset,
    setValue,
    formState: { errors },
  } = useForm<EditFormValues>({
    defaultValues: defaultValues(),
  })

  return (
    <>
      {editModal && (
        <ModalWrapper>
          <form
            className="modal-card"
            onSubmit={handleSubmit(async data => {
              const res: any = await post(`tickets/${ticket.id}/edit`, { data })
              if (res.error) {
                res.error.title &&
                  setError('title', { message: res.error.title })
              } else {
                setEditModal(false)
              }
            })}
          >
            <ModalHeader
              title={intl.formatMessage({
                id: 'ticket / edit / modal / title',
              })}
              onClose={close}
            />
            <ModalBody>
              {ticket.client && (
                <SelectClient
                  control={control}
                  tab={null}
                  errors={errors}
                  allowAnonymous={false}
                />
              )}
              <TicketForm
                control={control}
                setValue={setValue}
                edit={true}
                ticket={ticket}
                tab={null}
              />
            </ModalBody>
            <ModalFooterInForm onCancel={close} isSubmitting={isSubmitting} />
          </form>
        </ModalWrapper>
      )}
    </>
  )
}

export default EditModal
